import type { EnvHandlerContract } from '@sparklayer-io/spark-dash-core/types/handlers/env';
import { defaultSiteEnv, useAuthStore, useEnvStore } from '../session';

/**
 * React-host implementation of the env contract, backed by the Zustand env store. Used by pages
 * that run before a site is fully mounted (getting-ready, auth) or that reload site readiness.
 * Resolves the user's current team's environment fresh on every call - `force: true` so a poller
 * (e.g. `/getting-ready`) keeps refetching instead of the store skipping an unchanged site/env.
 */
export const envHandler: EnvHandlerContract = {
  async reload() {
    await useAuthStore.getState().loadUser();
    const user = useAuthStore.getState().data;
    const currentTeam = user?.currentTeam;
    if (!currentTeam) return { isReady: false, hasPlatform: false, isPartner: false };

    const siteId = currentTeam.slugged_name;
    const siteEnv = defaultSiteEnv(user, siteId) ?? 'live';
    await useEnvStore.getState().loadEnv({ siteId, siteEnv }, { fallback: 'any', force: true });

    const env = useEnvStore.getState().env;
    return {
      isReady: !!env?.db_created,
      hasPlatform: env?.platform != null,
      isPartner: !!env?.team.is_partner,
    };
  },
};
